import React, {FC, useMemo, useState} from "react"
import {Deal, PaymentCurrencyType, Wallet} from "@irati/types"
import {Card} from "@irati/ui/src/Layout"
import withBasket, {WithBasket} from "@irati/checkout/utils/basket/withBasket"
import {Col} from "@irati/ui/src/ColumnRow"
import {Body, H4} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Summary from "./Summary"
import {MobileFlex} from "./styled"

interface Props extends WithBasket {
  deal: Deal,
  rewardWallet?: Wallet
}

const MerchandiseOrderSummary: FC<Props> = ({deal, basket, rewardWallet}) => {
  const [show, setShow] = useState(false)

  const totalLeft = useMemo(() => {
    if (rewardWallet && basket.breakdown.total) {
      return rewardWallet.amount - basket.breakdown.total.amount
    }

    return null
  }, [rewardWallet?.amount, basket.breakdown.total?.amount])

  const toggleShowSummary = () => {
    setShow((current) => !current)
  }

  return (
    <>
      {/* Desktop */}
      <Col xsHidden paddingLeft={4} paddingRight={4}>
        <Card padding={2}>
          <H4 marginBottom={2}>
            <FormattedMessage id="flexiRewards.merchandise.checkout.summary.header" />
          </H4>
          <Summary deal={deal} totalLeft={totalLeft} basket={basket} />
        </Card>
      </Col>

      {/* Mobile */}
      <Col smHidden mdHidden lgHidden>
        <MobileFlex>
          <Flex direction="row" justifyContent="space-between" width="100%" onClick={toggleShowSummary}>
            <H4>
              <FormattedMessage id="flexiRewards.merchandise.checkout.summary.header" />
            </H4>
            <Flex alignItems="center" gap={theme.spacing.one}>
              <Body weight="bold">
                <FormattedCurrency isCents currency={PaymentCurrencyType.Rp} value={basket.breakdown.total?.amount} />
              </Body>
              <Body weight="bold">(1 item)</Body>
              <Icon extraLarge icon={show ? IconTypes.chevronUp : IconTypes.chevronDown} />
            </Flex>
          </Flex>
          {show && <Summary deal={deal} totalLeft={totalLeft} basket={basket} />}
        </MobileFlex>
      </Col>
    </>
  )
}

export default withBasket(MerchandiseOrderSummary)
